import { PlanTab } from '../Modules/Plans/Interfaces/plan-tab.interface';
import { SystemRole } from '../Enums/system-role.enum';

export const PLAN_TABS: readonly PlanTab[] = [
  { id: 'overview', label: 'backoffice.plans.tabs.overview', icon: 'info' },
  { id: 'prices', label: 'backoffice.plans.tabs.prices', icon: 'sell' },
  { id: 'features', label: 'backoffice.plans.tabs.features', icon: 'checklist' },
  { id: 'subscribers', label: 'backoffice.plans.tabs.subscribers', icon: 'corporate_fare' },
];

export const PLAN_DEFAULT_TAB = 'overview';

export const PLAN_TAB_QUERY_PARAM = 'tab';

export const ROLE_PLAN_WRITE = SystemRole.BACKOFFICE_BILLING_ADMIN;

export const PLAN_STATUS_OPTIONS: readonly string[] = ['active', 'inactive'];

export const PLAN_STATUS_LABEL: Readonly<Record<string, string>> = {
  active: 'backoffice.enums.plan_status.active',
  inactive: 'backoffice.enums.plan_status.inactive',
};

export const OFFER_TYPE_OPTIONS: readonly string[] = ['monthly', 'commit12'];

export const OFFER_TYPE_LABEL: Readonly<Record<string, string>> = {
  monthly: 'backoffice.enums.offer_type.monthly',
  commit12: 'backoffice.enums.offer_type.commit12',
};

export const BILLING_INTERVAL_OPTIONS: readonly string[] = ['month', 'year'];

export const BILLING_INTERVAL_LABEL: Readonly<Record<string, string>> = {
  month: 'backoffice.enums.billing_interval.month',
  year: 'backoffice.enums.billing_interval.year',
};

export const PLAN_CODE_MAX = 50;

export const PLAN_NAME_MAX = 120;

export const PRICE_AMOUNT_MAX = 999999.99;

export const FEATURE_AGENT_KEY = 'agent';
